/* ══════════════════════════════════════════════════════════════════
   O CSS de toda página publicada pelo ADS.
   Nenhuma cor, fonte ou raio é do ADS: tudo lê os papéis do design
   system do cliente (--ds-role-*), com um fallback neutro e sóbrio.
   Sem JavaScript. Animação só por CSS, e só para quem aceita movimento.
   ══════════════════════════════════════════════════════════════════ */
export const SITE_CSS = String.raw`
*,*::before,*::after{box-sizing:border-box}
html{-webkit-text-size-adjust:100%;scroll-behavior:smooth;scroll-padding-top:84px}
body{
  --p:var(--ds-role-primary,#1f2430);
  --a:var(--ds-role-accent,#c8612a);
  --hl:var(--ds-role-highlight,var(--a));
  --wash:var(--ds-role-wash,#f6eee8);
  --ink:var(--ds-role-ink,#1c1a18);
  --ink2:var(--ds-role-ink-muted,#645e57);
  --on:var(--ds-role-on-primary,#fff);
  --bg:var(--ds-role-surface,#faf8f5);
  --card:var(--ds-role-surface-raised,#fff);
  --sunk:var(--ds-role-surface-sunken,#f1ede7);
  --deep:var(--ds-role-surface-brand,var(--p));
  --line:var(--ds-role-line,#e6e0d7);
  --line2:var(--ds-role-line-strong,#b8afa2);
  --fh:var(--ds-role-font-heading,Georgia,"Times New Roman",serif);
  --fb:var(--ds-role-font-body,system-ui,-apple-system,"Segoe UI",sans-serif);
  --r:var(--ds-role-radius,12px);
  --sh:var(--ds-role-shadow,0 1px 2px rgb(0 0 0/.05),0 14px 36px -12px rgb(0 0 0/.14));
  --grad:var(--ds-role-gradient,var(--p) 0%,var(--a) 100%);
  --wrap:1160px;
  margin:0;background:var(--bg);color:var(--ink);font-family:var(--fb);font-size:17px;line-height:1.65;
  -webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;font-feature-settings:"kern","liga";
}
img,svg{display:block;max-width:100%}
a{color:inherit}
h1,h2,h3{font-family:var(--fh);font-weight:400;margin:0;color:var(--p);text-wrap:balance;letter-spacing:-.015em}
p{margin:0;text-wrap:pretty}
strong{font-weight:600;color:var(--p)}
:focus-visible{outline:2px solid var(--a);outline-offset:3px;border-radius:4px}
::selection{background:color-mix(in srgb,var(--a) 24%,transparent)}
.s-wrap{max-width:var(--wrap);margin:0 auto;padding-inline:clamp(20px,5vw,48px)}
.s-skip{position:absolute;left:-999px;top:8px;background:var(--card);padding:8px 14px;border-radius:8px;z-index:20}
.s-skip:focus{left:12px}

/* ── navegação ── */
.s-nav{position:sticky;top:0;z-index:10;background:color-mix(in srgb,var(--bg) 84%,transparent);
  backdrop-filter:blur(16px) saturate(1.4);-webkit-backdrop-filter:blur(16px) saturate(1.4);border-bottom:1px solid color-mix(in srgb,var(--line) 70%,transparent)}
.s-nav-in{display:flex;align-items:center;gap:28px;height:72px}
.s-brand{display:flex;align-items:center;gap:11px;text-decoration:none;font-family:var(--fh);font-size:19px;color:var(--p);flex:none}
.s-brand img{width:34px;height:34px}
.s-links{display:flex;gap:26px;margin-left:auto;font-size:15px}
.s-links a{text-decoration:none;color:var(--ink2);padding:6px 0;border-bottom:1.5px solid transparent;transition:color .2s,border-color .2s;white-space:nowrap}
.s-links a:hover,.s-links a[aria-current=page]{color:var(--p);border-bottom-color:var(--a)}
.s-nav .s-btn{margin-left:8px}
.s-links:empty + .s-btn{margin-left:auto}
.s-menu{display:none;position:relative}
.s-menu summary{list-style:none;width:44px;height:44px;border-radius:12px;display:grid;place-items:center;cursor:pointer;color:var(--p)}
.s-menu summary::-webkit-details-marker{display:none}
.s-menu summary i,.s-menu summary i::before,.s-menu summary i::after{display:block;width:18px;height:1.5px;background:currentColor;border-radius:1px;transition:transform .25s,opacity .2s}
.s-menu summary i{position:relative}
.s-menu summary i::before,.s-menu summary i::after{content:"";position:absolute;left:0}
.s-menu summary i::before{top:-6px}
.s-menu summary i::after{top:6px}
.s-menu[open] summary i{background:transparent}
.s-menu[open] summary i::before{transform:translateY(6px) rotate(45deg)}
.s-menu[open] summary i::after{transform:translateY(-6px) rotate(-45deg)}
.s-menu-p{position:absolute;right:0;top:52px;min-width:220px;display:flex;flex-direction:column;padding:8px;border-radius:var(--r);background:var(--card);box-shadow:var(--sh),0 0 0 1px var(--line)}
.s-menu-p a{padding:12px 14px;border-radius:calc(var(--r) - 4px);text-decoration:none;color:var(--ink);font-size:16px}
.s-menu-p a[aria-current=page]{color:var(--p);background:var(--wash)}

/* ── botões ── */
.s-btn{display:inline-flex;align-items:center;gap:10px;height:50px;padding:0 26px;border-radius:999px;font:600 15px/1 var(--fb);
  text-decoration:none;white-space:nowrap;transition:transform .2s cubic-bezier(.2,.8,.2,1),box-shadow .2s,background-color .2s,filter .2s;cursor:pointer}
.s-btn svg{width:15px;height:15px;transition:transform .25s cubic-bezier(.2,.8,.2,1)}
.s-btn:hover svg{transform:translateX(3px)}
.s-btn-a{background:var(--a);color:var(--on);box-shadow:0 1px 2px rgb(0 0 0/.12),0 8px 22px -8px color-mix(in srgb,var(--a) 70%,transparent)}
.s-btn-a:hover{filter:brightness(1.06);transform:translateY(-1px)}
.s-btn-p{background:var(--p);color:var(--on)}
.s-btn-p:hover{filter:brightness(1.12);transform:translateY(-1px)}
.s-btn-ghost{color:var(--on);box-shadow:inset 0 0 0 1.5px color-mix(in srgb,var(--on) 40%,transparent)}
.s-btn-ghost:hover{box-shadow:inset 0 0 0 1.5px var(--on)}
.s-btn-sm{height:40px;padding:0 18px;font-size:14px}

/* ── herói ── */
.s-hero{position:relative;isolation:isolate;overflow:hidden;color:var(--on);
  background:
    radial-gradient(60% 80% at 100% 110%,color-mix(in srgb,var(--a) 46%,transparent) 0%,transparent 60%),
    radial-gradient(34% 46% at 94% 112%,color-mix(in srgb,var(--hl) 52%,transparent) 0%,transparent 70%),
    linear-gradient(160deg,color-mix(in srgb,var(--deep) 84%,#fff) 0%,var(--deep) 40%,color-mix(in srgb,var(--deep) 78%,#000) 100%)}
.s-hero-in{position:relative;padding-block:clamp(88px,14vh,150px) clamp(96px,16vh,170px)}
.s-hero .s-eyebrow{color:color-mix(in srgb,var(--on) 72%,transparent)}
.s-hero .s-eyebrow::before{background:var(--a)}
.s-hero h1{color:var(--on);font-weight:300;font-size:clamp(42px,6.4vw,82px);line-height:1.02;letter-spacing:-.025em;max-width:15ch}
.s-hero .s-lead{margin-top:28px;max-width:40ch;font-size:clamp(18px,1.6vw,21px);line-height:1.55;color:color-mix(in srgb,var(--on) 82%,transparent)}
.s-hero .s-actions{margin-top:40px}
.s-hero-art{position:absolute;z-index:-1;right:-10%;bottom:-58%;width:min(78vw,900px);aspect-ratio:1;pointer-events:none}
.s-hero-art i{position:absolute;inset:0;border-radius:50%;border:1px solid color-mix(in srgb,var(--on) 16%,transparent)}
.s-hero-art i:nth-child(2){inset:12%;border-color:color-mix(in srgb,var(--on) 11%,transparent)}
.s-hero-art i:nth-child(3){inset:24%;border-color:color-mix(in srgb,var(--on) 8%,transparent)}
.s-hero strong,.s-cta strong{color:inherit;font-weight:inherit}
.s-hero h1 strong,.s-cta h2 strong{color:color-mix(in srgb,var(--hl) 80%,var(--on))}
.s-hero.sm .s-hero-in{padding-block:clamp(64px,10vh,112px)}
.s-hero.sm h1{font-size:clamp(36px,4.8vw,62px);max-width:20ch}
.s-hero.sm .s-hero-art{bottom:-110%;right:-20%;width:min(70vw,760px)}
.s-hero::after{content:"";position:absolute;left:0;right:0;bottom:0;height:4px;background:linear-gradient(90deg,var(--grad))}

.s-eyebrow{display:flex;align-items:center;gap:12px;margin-bottom:22px;font:600 12.5px/1 var(--fb);letter-spacing:.14em;text-transform:uppercase;color:var(--ink2)}
.s-eyebrow::before{content:"";width:32px;height:1.5px;background:var(--a)}
.s-actions{display:flex;flex-wrap:wrap;gap:14px}

/* ── faixas ── */
.s-band{padding-block:clamp(64px,8.5vw,116px)}
.s-band.alt{background:var(--sunk)}
/* duas faixas no mesmo fundo: o respiro não soma */
.s-band:not(.alt):not(.wash) + .s-band:not(.alt):not(.wash){padding-top:0}
.s-band-h{max-width:720px;margin-bottom:clamp(40px,5vw,64px)}
.s-band-h h2{font-size:clamp(32px,3.8vw,50px);line-height:1.08}
.s-band-h p{margin-top:18px;font-size:19px;color:var(--ink2);max-width:58ch}

/* cartões */
.s-grid{display:grid;gap:20px;grid-template-columns:repeat(auto-fit,minmax(min(100%,300px),1fr))}
.s-grid.n2{grid-template-columns:repeat(auto-fit,minmax(min(100%,420px),1fr))}
.s-card{position:relative;padding:34px 30px 32px;border-radius:var(--r);background:var(--card);box-shadow:var(--sh);overflow:hidden}
.s-card::before{content:"";position:absolute;left:30px;top:0;width:36px;height:3px;background:var(--a);border-radius:0 0 3px 3px}
.s-card-no{display:block;font:600 13px/1 var(--fb);color:var(--a);letter-spacing:.06em;margin-bottom:34px;font-variant-numeric:tabular-nums}
.s-card h3{font-size:24px;line-height:1.2;margin-bottom:12px}
.s-card p{color:var(--ink2);font-size:16px;line-height:1.62}

/* passos */
.s-steps{list-style:none;margin:0;padding:0;display:grid;gap:28px;grid-template-columns:repeat(auto-fit,minmax(min(100%,220px),1fr));counter-reset:s}
.s-steps li{position:relative;padding-top:64px;counter-increment:s}
.s-steps li::before{content:counter(s);position:absolute;top:0;left:0;width:44px;height:44px;border-radius:50%;display:grid;place-items:center;
  font:600 16px/1 var(--fb);color:var(--on);background:var(--p);box-shadow:0 0 0 6px var(--sunk)}
.s-steps li::after{content:"";position:absolute;top:22px;left:56px;right:-16px;height:1.5px;background:linear-gradient(90deg,var(--line2),transparent)}
.s-steps li:last-child::after{display:none}
.s-steps h3{font-size:21px;margin-bottom:8px}
.s-steps p{color:var(--ink2);font-size:16px}

/* números */
.s-stats{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,200px),1fr));border-top:1px solid var(--line);border-bottom:1px solid var(--line)}
.s-stat{padding:34px 28px 30px 0}
.s-stat + .s-stat{padding-left:28px;border-left:1px solid var(--line)}
.s-stat b{display:block;font:300 clamp(40px,4.6vw,60px)/1 var(--fh);color:var(--p);letter-spacing:-.02em}
.s-stat span{display:block;margin-top:14px;color:var(--ink2);font-size:15px;line-height:1.45;max-width:26ch}

/* depoimento */
.s-band.wash{background:var(--wash)}
.s-quote{max-width:880px;margin:0 auto;text-align:center}
.s-quote blockquote{margin:0;font:300 clamp(26px,3vw,38px)/1.3 var(--fh);color:var(--p);letter-spacing:-.012em;text-wrap:balance}
.s-quote blockquote::before{content:"“";display:block;font-size:1.9em;line-height:.6;color:var(--a);margin-bottom:10px}
.s-quote figcaption{margin-top:28px;font-size:15px;color:var(--ink2)}
.s-quote figcaption b{display:block;color:var(--ink);font-weight:600;margin-bottom:2px}

/* perguntas */
.s-faq{display:grid;grid-template-columns:minmax(0,.8fr) minmax(0,1.2fr);gap:clamp(32px,6vw,96px);align-items:start}
.s-faq .s-band-h{margin:0;position:sticky;top:110px}
.s-faq-list{border-top:1px solid var(--line)}
.s-faq details{border-bottom:1px solid var(--line)}
.s-faq summary{list-style:none;cursor:pointer;display:flex;justify-content:space-between;gap:24px;padding:24px 0;font:500 19px/1.35 var(--fh);color:var(--p)}
.s-faq summary::-webkit-details-marker{display:none}
.s-faq summary::after{content:"";flex:none;width:14px;height:14px;margin-top:5px;
  background:linear-gradient(var(--a),var(--a)) center/100% 1.5px no-repeat,linear-gradient(var(--a),var(--a)) center/1.5px 100% no-repeat;transition:transform .3s}
.s-faq details[open] summary::after{transform:rotate(45deg)}
.s-faq details p{padding:0 40px 26px 0;color:var(--ink2)}

/* chamada final */
.s-cta{position:relative;isolation:isolate;overflow:hidden;color:var(--on);text-align:center;
  background:radial-gradient(70% 120% at 50% 130%,color-mix(in srgb,var(--a) 50%,transparent),transparent 65%),var(--deep)}
.s-cta .s-wrap{padding-block:clamp(88px,12vw,140px)}
.s-cta h2{color:var(--on);font-weight:300;font-size:clamp(34px,4.6vw,60px);line-height:1.06;max-width:18ch;margin:0 auto}
.s-cta p{margin:22px auto 0;max-width:46ch;font-size:19px;color:color-mix(in srgb,var(--on) 80%,transparent)}
.s-cta .s-actions{justify-content:center;margin-top:38px}

/* conteúdo corrido */
.s-prose{max-width:740px}
.s-prose > * + *{margin-top:22px}
.s-prose h2{font-size:clamp(30px,3.4vw,44px);line-height:1.1;margin-bottom:6px}
.s-prose h3{font-size:24px;margin-top:40px}
.s-prose p{font-size:18px;line-height:1.72}
.s-prose ul,.s-prose ol{padding:0;list-style:none;display:grid;gap:12px}
.s-prose li{position:relative;padding-left:30px;font-size:17px}
.s-prose ul li::before{content:"";position:absolute;left:4px;top:.78em;width:10px;height:2px;background:var(--a)}
.s-prose ol{counter-reset:o}
.s-prose ol li{counter-increment:o}
.s-prose ol li::before{content:counter(o,decimal-leading-zero);position:absolute;left:0;top:.18em;font:600 13px/1 var(--fb);color:var(--a)}
.s-prose blockquote{margin:36px 0;padding-left:28px;border-left:2px solid var(--a);font:300 28px/1.3 var(--fh);color:var(--p)}
.s-prose blockquote cite{display:block;margin-top:12px;font:600 12px/1 var(--fb);letter-spacing:.12em;text-transform:uppercase;color:var(--ink2)}
.s-note{padding:18px 22px;border-radius:var(--r);background:var(--wash);box-shadow:inset 3px 0 0 var(--a);font-size:16px}
.s-metrics{display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:0;border-top:1px solid var(--line);border-bottom:1px solid var(--line)}
.s-metrics div{padding:22px 18px 20px 0}
.s-metrics b{display:block;font:300 38px/1 var(--fh);color:var(--p)}
.s-metrics span{display:block;margin-top:10px;font-size:14px;color:var(--ink2)}
.s-table{overflow-x:auto}
.s-table table{width:100%;border-collapse:collapse;font-size:15px}
.s-table th{text-align:left;font:600 12px/1.2 var(--fb);letter-spacing:.06em;text-transform:uppercase;color:var(--ink2);padding:0 16px 12px 0;border-bottom:1.5px solid var(--p)}
.s-table caption{caption-side:top;text-align:left;padding-bottom:14px;font-size:14px;color:var(--ink2)}
.s-table td{padding:13px 16px 13px 0;border-bottom:1px solid var(--line);vertical-align:top}
.s-bars{display:grid;gap:12px}
.s-bars div{display:grid;grid-template-columns:minmax(90px,180px) 1fr 48px;gap:14px;align-items:center;font-size:15px}
.s-bars i{display:block;height:10px;border-radius:5px;background:var(--sunk);overflow:hidden}
.s-bars i::before{content:"";display:block;height:100%;width:var(--v);background:var(--p);border-radius:5px}

/* ── rodapé ── */
.s-foot{background:color-mix(in srgb,var(--deep) 92%,#000);color:color-mix(in srgb,var(--on) 72%,transparent);font-size:14px}
.s-foot-in{display:grid;grid-template-columns:1.2fr 1fr 1fr;gap:40px;padding-block:64px 40px}
.s-foot .s-brand{color:var(--on)}
.s-foot h4{margin:0 0 14px;font:600 12px/1 var(--fb);letter-spacing:.12em;text-transform:uppercase;color:color-mix(in srgb,var(--on) 55%,transparent)}
.s-foot ul{list-style:none;margin:0;padding:0;display:grid;gap:9px}
.s-foot a{text-decoration:none}
.s-foot a:hover{color:var(--on)}
.s-foot-base{display:flex;justify-content:space-between;gap:20px;flex-wrap:wrap;padding-block:22px 30px;border-top:1px solid color-mix(in srgb,var(--on) 12%,transparent);font-size:13px;color:color-mix(in srgb,var(--on) 50%,transparent)}
.s-foot p{max-width:34ch;margin-top:16px;line-height:1.6}

/* ── telas estreitas ── */
@media (max-width:860px){
  .s-links{display:none}
  .s-menu{display:block}
  .s-nav .s-btn{margin-left:auto}
  .s-nav .s-btn + .s-menu{margin-left:4px}
  .s-nav-in > .s-menu:nth-child(3){margin-left:auto}
  .s-faq{grid-template-columns:1fr}
  .s-faq .s-band-h{position:static}
  .s-foot-in{grid-template-columns:1fr}
  .s-stat + .s-stat{padding-left:0;border-left:0;border-top:1px solid var(--line)}
  .s-steps li::after{display:none}
}
@media (max-width:520px){
  body{font-size:16px}
  .s-nav-in{height:64px}
  .s-brand img + span{display:none}
  .s-nav .s-btn-sm{padding:0 14px}
  .s-btn{height:46px;padding:0 20px}
  .s-hero h1{font-size:40px}
}

/* ── movimento: só CSS, só para quem aceita ── */
@media (prefers-reduced-motion:no-preference){
  .s-hero-in > *{animation:s-up .9s cubic-bezier(.2,.8,.2,1) both}
  .s-hero-in > :nth-child(2){animation-delay:.08s}
  .s-hero-in > :nth-child(3){animation-delay:.16s}
  .s-hero-in > :nth-child(4){animation-delay:.24s}
  @supports (animation-timeline:view()){
    .s-reveal{animation:s-up linear both;animation-timeline:view();animation-range:entry 0% entry 42%}
  }
  [data-new]{animation:s-up .7s cubic-bezier(.2,.8,.2,1) both !important;animation-timeline:auto !important}
}
@keyframes s-up{from{opacity:0;transform:translateY(22px)}}
@media print{
  .s-reveal,[data-new],.s-hero-in>*{animation:none!important}
  .s-nav{position:static}
  .s-hero,.s-cta,.s-foot{-webkit-print-color-adjust:exact;print-color-adjust:exact}
}
`;
